export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";

export const GET_SINGLE_PRODUCT = "GET_SINGLE_PRODUCT";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_ERROR = "GET_SINGLE_PRODUCT_ERROR";

export const GET_CATEGORIES_WITH_PRODUCTS = "GET_CATEGORIES_WITH_PRODUCTS";
export const GET_CATEGORIES_WITH_PRODUCTS_SUCCESS = "GET_CATEGORIES_WITH_PRODUCTS_SUCCESS";
export const GET_CATEGORIES_WITH_PRODUCTS_ERROR = "GET_CATEGORIES_WITH_PRODUCTS_ERROR";

export const GET_PRODUCT_CATEGORIES = "GET_PRODUCT_CATEGORIES";
export const GET_PRODUCT_CATEGORIES_SUCCESS = "GET_PRODUCT_CATEGORIES_SUCCESS";
export const GET_PRODUCT_CATEGORIES_ERROR = "GET_PRODUCT_CATEGORIES_ERROR";